<template>
  <div class="download-file">
    <DownloadSnackbar :value="descargando"
                      :progreso-descarga="progresoDescarga"
                      :total-descarga="totalDescarga"
    ></DownloadSnackbar>
    <a hidden ref="fileAnchor" />
  </div>
</template>

<script>
import DownloadSnackbar from '@/components/DownloadSnackbar';

export default {
name: "DownloadFile",
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  components: {DownloadSnackbar},
  data: () => ({
    progresoDescarga: null,
    totalDescarga: null,
    descargando: false,
  }),
  mounted() {
    this.download();
  },
  methods: {
    download() {
      this.descargando = true;
      return this.$http.get(`${process.env.VUE_APP_ROOT_API}${this.url}`, {
        responseType: 'blob',
        headers: {
          Accept: '*/*',
        },
        downloadProgress(evt) {
          if (evt.lengthComputable) {
            this.progresoDescarga = evt.loaded;
            this.totalDescarga = evt.total;
          }
        },
      }).then(r => {
        this.totalDescarga = this.progresoDescarga = null;
        this.descargando = false;
        const nombre = r.headers.get('content-disposition')
            .split(';')
            .find(cd => cd.includes('filename'))
            .split('=')[1]
            .split('"').join(''); // para quitar el caracter "
        return r.blob().then(b => ({
          blob: b,
          nombre
        }));
      },
          () => {
            this.totalDescarga = this.progresoDescarga = null;
            this.descargando = false;
            this.$emit('finDescarga');
          }
      ).then(
          b => {
            const anchor = this.$refs.fileAnchor;
            anchor.download = b.nombre;
            anchor.href = URL.createObjectURL(b.blob);
            anchor.click();
            this.$emit('finDescarga');
          }
      );
    },
  },
}
</script>

<style scoped>

</style>
